import { render, staticRenderFns } from "./StationNav.vue?vue&type=template&id=06338347&scoped=true"
import script from "./StationNav.vue?vue&type=script&lang=js"
export * from "./StationNav.vue?vue&type=script&lang=js"
import style0 from "./StationNav.vue?vue&type=style&index=0&id=06338347&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06338347",
  null
  
)

export default component.exports